export enum InvoiceType {
  OFFER_ISSUED = 'OFFER_ISSUED',
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  INVOICE_ISSUED = 'INVOICE_ISSUED',
  OFFER_RECEIVED = 'OFFER_RECEIVED',
  ORDER_ISSUED = 'ORDER_ISSUED',
  INVOICE_RECEIVED = 'INVOICE_RECEIVED',
  UNKNOWN = 'UNKNOWN',
}

export interface InvoiceApiParams {
  baseType: string;
  isIssued: string;
  draftType: string;
  journalType: string;
  title?: string;
  filterTitle?: string;
}

type TranslateFn = (key: string) => string;

const APP_IDENT_TO_INVOICE_TYPE: Record<string, InvoiceType> = {
  'com.atollon.invoice.offer-issued': InvoiceType.OFFER_ISSUED,
  'com.atollon.invoice.order-received': InvoiceType.ORDER_RECEIVED,
  'com.atollon.invoice.invoice-issued': InvoiceType.INVOICE_ISSUED,
  'com.atollon.invoice.offer-received': InvoiceType.OFFER_RECEIVED,
  'com.atollon.invoice.order-issued': InvoiceType.ORDER_ISSUED,
  'com.atollon.invoice.invoice-received': InvoiceType.INVOICE_RECEIVED,
};

const VIEW_COMPONENT_TO_INVOICE_TYPE: Record<string, InvoiceType> = {
  'com.atollon.BudgetList': InvoiceType.OFFER_ISSUED,
  'com.atollon.IssuedOffer': InvoiceType.OFFER_ISSUED,
  'com.atollon.IssuedOfferList': InvoiceType.OFFER_ISSUED,
  'com.atollon.ReceivedOffer': InvoiceType.OFFER_RECEIVED,
  'com.atollon.ReceivedOfferList': InvoiceType.OFFER_RECEIVED,
  'com.atollon.ReceivedInvoiceList': InvoiceType.INVOICE_RECEIVED,
  'com.atollon.IssuedInvoiceList': InvoiceType.INVOICE_ISSUED,
  'com.atollon.ReceivedOrderList': InvoiceType.ORDER_RECEIVED,
  'com.atollon.IssuedOrderList': InvoiceType.ORDER_ISSUED,
};

export const mapAppIdentToInvoiceType = (appIdent: string): InvoiceType => {
  return APP_IDENT_TO_INVOICE_TYPE[appIdent] ?? InvoiceType.UNKNOWN;
};

export const mapViewComponentToInvoiceType = (viewComponent: string): InvoiceType => {
  return VIEW_COMPONENT_TO_INVOICE_TYPE[viewComponent] ?? InvoiceType.UNKNOWN;
};

export const mapInvoiceTypeToApiParams = (invoiceType: InvoiceType, t: TranslateFn): InvoiceApiParams => {
  switch (invoiceType) {
    case InvoiceType.INVOICE_ISSUED:
      return {
        baseType: '1',
        isIssued: '1',
        draftType: '1',
        journalType: '1',
        filterTitle: t('all_issued_invoices'),
      };
    case InvoiceType.INVOICE_RECEIVED:
      return {
        baseType: '1',
        isIssued: '0',
        draftType: '1',
        journalType: '6',
        filterTitle: t('all_received_invoices'),
      };
    case InvoiceType.ORDER_ISSUED:
      return {
        baseType: '2',
        isIssued: '1',
        draftType: '1',
        journalType: '7',
        filterTitle: t('all_purchase_orders'),
      };
    case InvoiceType.ORDER_RECEIVED:
      return {
        baseType: '2',
        isIssued: '0',
        draftType: '1',
        journalType: '3',
        filterTitle: t('all_sales_orders'),
      };
    case InvoiceType.OFFER_ISSUED:
      return {
        baseType: '4',
        isIssued: '0',
        draftType: '1',
        journalType: '8',
        filterTitle: t('all_estimates'),
      };
    case InvoiceType.OFFER_RECEIVED:
      return {
        baseType: '8',
        isIssued: '0',
        draftType: '1',
        journalType: '13',
        filterTitle: t('all_received_offers'),
      };
    case InvoiceType.UNKNOWN:
    default:
      return {
        baseType: '0',
        isIssued: '0',
        draftType: '0',
        journalType: '0',
      };
  }
};

export const mapInvoiceTypeToAppIdent = (invoiceType: InvoiceType): string => {
  switch (invoiceType) {
    case InvoiceType.OFFER_ISSUED:
      return 'com.atollon.invoice.offer-issued';
    case InvoiceType.ORDER_RECEIVED:
      return 'com.atollon.invoice.order-received';
    case InvoiceType.INVOICE_ISSUED:
      return 'com.atollon.invoice.invoice-issued';
    case InvoiceType.OFFER_RECEIVED:
      return 'com.atollon.invoice.offer-received';
    case InvoiceType.ORDER_ISSUED:
      return 'com.atollon.invoice.order-issued';
    case InvoiceType.INVOICE_RECEIVED:
      return 'com.atollon.invoice.invoice-received';
    case InvoiceType.UNKNOWN:
    default:
      return 'com.atollon.invoice.invoice-issued';
  }
};
